import React from 'react';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import data from './elem_seguridad.json'

export class elem_seguridad extends React.Component {

	


	render(){

		return (
				<div id="inicio">
					
					<section class="container-fluid section-nuestros-productos">
					<article class="row">
					
							
											<div class="col-md-12 card-col-flex">


							<table class="table card-lb">
								<thead>
									<tr>
										<th scope="col">#</th>
										<th scope="col">Accesorios</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th scope="row">1</th>
										<td>CARETA PARA SOLDAR</td>		
									</tr>
									<tr>
										<th scope="row">2</th>
										<td>VIDRIOS (DISTINTOS DINES)</td>
									</tr>
									<tr>
										<th scope="row">3</th>
										<td>GUANTES (VARIEDAD)</td>
									</tr>
									<tr>
										<th scope="row">4</th>
										<td>ANTIPARRAS</td>
									</tr>
									<tr>
										<th scope="row">5</th>
										<td>TAPONES AUDITIVOS</td>
									</tr>
									<tr>
										<th scope="row">6</th>
										<td>FAJA LUMBAR</td>
									</tr>
									<tr>
										<th scope="row">7</th>
										<td>TRACA</td>
									</tr>
									<tr>
										<th scope="row">8</th>
										<td>ESLINGA</td>
									</tr>
									<tr>
										<th scope="row">9</th>
										<td>CARETA PROTECTORA FACIAL</td>
									</tr>
									<tr>
										<th scope="row">10</th>
										<td>CINTA PELIGRO</td>
									</tr>
									<tr>
										<th scope="row">11</th>
										<td>CONO VIALES</td>
									</tr>
									<tr>
										<th scope="row">12</th>
										<td>CASCO</td>
									</tr>
									<tr>
										<th scope="row">13</th>
										<td>BARBIJO</td>
									</tr>
								</tbody>
								<tfoot>
									<tr>		
									<td colspan="2" className="text-center"><button className="topScroll linkTable">subir</button></td>
									</tr>
								</tfoot>
							</table>

						</div>
						
					</article>
				</section>		


				</div>

				


				);
	}
} 


// WEBPACK FOOTER //
// ./src/components/elem_seguridad.js